import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useTheme } from "@/hooks";
import { PanelCard, SwitchInput } from "@/components/common";


/**
 * Injects the app theme.
 */
const __default__ = {
  name: "ThemeController",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { darkMode, toggleDarkMode } = useTheme();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: "Theme" }, {
    default: _withCtx(() => [
      _createVNode(_unref(SwitchInput), {
        label: "Enable dark mode",
        "model-value": _unref(darkMode),
        "onUpdate:modelValue": _unref(toggleDarkMode)
      }, null, 8, ["model-value", "onUpdate:modelValue"])
    ]),
    _: 1
  }))
}
}

})